import _get from 'lodash/get';
import { ENTITY_REFERENCE_TYPES } from '../../../constants/parts/entityReferenceTypes';
import { NO_DATA } from '../../../app.constants';
export var getSorReferenceNumber = function getSorReferenceNumber(sorDetails) {
  var refType = sorDetails.refType,
      referenceNumber = sorDetails.referenceNumber,
      additional = sorDetails.additional;

  switch (refType) {
    case ENTITY_REFERENCE_TYPES.CUSTOMER:
      {
        return referenceNumber;
      }

    case ENTITY_REFERENCE_TYPES.SALES_ORDER:
      {
        return referenceNumber;
      }

    case ENTITY_REFERENCE_TYPES.FULFILMENT:
      {
        return _get(additional, 'roNumber', NO_DATA);
      }

    default:
      return '';
  }
};